export default "__VITE_ASSET__7342167f__"